"use client";
import React from "react";

type Props = {
  children: React.ReactNode;
  assetOverlay: React.ReactNode;
  productOverlay: React.ReactNode;
};
export default function KitLayout({ children, assetOverlay, productOverlay }: Props) {
  return (
    <>
      {children}
      {assetOverlay}
      {productOverlay}
    </>
  );
}
